import React from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

import { IndividualRuleSchema, StopTimeRuleExceptionSchema } from "../../types";
import { GAP, GRID_FOUR_COLUMNS } from "../../utils";

import DeadlineRow from "./DeadlineRow";

export interface DeadlinesSectionProps {
  rule: IndividualRuleSchema | undefined;
  isEditing: boolean;
  onRuleChange: (newRule: IndividualRuleSchema) => void;
  gap?: number;
  gridTemplateColumns?: string;
}

const DeadlinesSection: React.FC<DeadlinesSectionProps> = ({
  rule,
  isEditing,
  onRuleChange,
}) => {
  const handleAddDeadline = () => {
    if (rule == null) return;
    const newRule = {
      ...rule,
      times_exceptions: [
        ...rule.times_exceptions,
        { for_date: "", deadline_date: "", hour: 0, minute: 0 },
      ],
    };
    onRuleChange(newRule);
  };

  const handleDeleteDeadline = (index: number) => {
    if (rule == null) return;
    const newDeadlines = [...rule.times_exceptions];
    newDeadlines.splice(index, 1);
    onRuleChange({
      ...rule,
      times_exceptions: newDeadlines,
    });
  };

  const handleUpdateDeadline = (
    index: number,
    newDeadline: StopTimeRuleExceptionSchema,
  ) => {
    if (rule == null) return;
    const newDeadlines = [...rule.times_exceptions];
    newDeadlines[index] = newDeadline;
    onRuleChange({
      ...rule,
      times_exceptions: newDeadlines,
    });
  };

  return (
    <Box id="custom-deadlines">
      <Typography gutterBottom color="text.secondary" variant="subtitle2">
        Anpassade stopptider
      </Typography>
      <Box display="grid" gap={GAP / 4} gridTemplateColumns={GRID_FOUR_COLUMNS}>
        {!isEditing && rule?.times_exceptions.length === 0 && (
          <Typography color="text.secondary" variant="body2">
            Inga anpassade stopptider.
          </Typography>
        )}
        {!isEditing && rule != null && rule?.times_exceptions.length > 0 && (
          <Box display="grid" gridColumn="span 4" gridTemplateColumns="subgrid">
            <Typography
              color="text.secondary"
              gridColumn="span 1"
              variant="subtitle2"
            >
              Gäller
            </Typography>
            <Typography
              color="text.secondary"
              gridColumn="span 1"
              variant="subtitle2"
            >
              Stoppdag
            </Typography>
            <Typography
              color="text.secondary"
              gridColumn="span 1"
              variant="subtitle2"
            >
              Klockslag
            </Typography>
          </Box>
        )}

        {rule?.times_exceptions.map((deadline, index) => (
          <DeadlineRow
            key={deadline.for_date + index}
            deadline={deadline}
            isEditing={isEditing}
            onDelete={() => handleDeleteDeadline(index)}
            onUpdate={(newDeadline) => handleUpdateDeadline(index, newDeadline)}
          />
        ))}
        {isEditing && (
          <Box>
            <Button startIcon={<Add />} onClick={handleAddDeadline}>
              Lägg till
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DeadlinesSection;
